import { CenterJourneyDistribution } from '../../../lib/types/models/center/center-distributions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterJourneyDistribution(id: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.getJourneyDistribution.url, { id }))
    .get<CenterJourneyDistribution[]>()
}
